module.exports = __webpack_public_path__ + "img/icon-5.f45d5153.png";